import { render, staticRenderFns } from "./TransportationOrganizationComponent.vue?vue&type=template&id=6cc51f4e"
import script from "./TransportationOrganizationComponent.vue?vue&type=script&lang=js"
export * from "./TransportationOrganizationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports